import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Select } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownExtenderDirective } from '../directives';
import { FilelinkModule } from '../file-link-module/file-link-module.module';
import {
  DisableControlDirective,
  FormControlErrorTemplate,
  FormControlPipe,
  FormErrorComponent,
  GetFormControlPipe,
  HasControlErrorPipe,
  LocaleMaxLengthValidatorDirective,
  LocaleMinLengthValidatorDirective,
  LocaleRequiredDirective,
  OutlinedInputDirective,
  RequiredWithNoSpaceDirective,
} from '../forms-utils';
import { GetIconCssClassPipe, PropertyTranslatorPipe } from '../pipes';
import { DropdownFocusHandlerDirective } from './dropdown-focus-handler.directive';
import { DropDownValueExtenderDirective } from './dropdown-value-extender.directive';
import { MultiSelectExtenderDirective } from './multiselect-extender.directive';
import { MultiSelectFocusHandlerDirective } from './multiselect-focus-handler.directive';
import { SelectFooterContentDirective } from './select-footer-content.directive';
import { SelectGroupContentDirective } from './select-group-content.directive';
import { SelectItemContentDirective } from './select-item-content.directive';
import { SelectLabelContentDirective } from './select-label-content.directive';
import { SelectComponent } from './select.component';
import { SelectedItemContentDirective } from './selected-item-content.directive';
const components = [
  SelectComponent,
  DropDownValueExtenderDirective,
  SelectFooterContentDirective,
  SelectGroupContentDirective,
  SelectItemContentDirective,
  SelectLabelContentDirective,
  SelectedItemContentDirective,
  MultiSelectExtenderDirective,
];

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    AvatarModule,
    Select,
    MultiSelectModule,
    SkeletonModule,
    TranslateModule,
    FormsModule,
    PropertyTranslatorPipe,
    // to be able to use "pInputOutlined" directive
    FilelinkModule,
    MultiSelectFocusHandlerDirective,
    DropdownFocusHandlerDirective,
    GetIconCssClassPipe,
    //standalone
    DisableControlDirective,
    RequiredWithNoSpaceDirective,
    LocaleRequiredDirective,
    OutlinedInputDirective,
    FormControlPipe,
    GetFormControlPipe,
    FormErrorComponent,
    FormControlErrorTemplate,
    LocaleMaxLengthValidatorDirective,
    LocaleMinLengthValidatorDirective,
    HasControlErrorPipe,
    DropdownExtenderDirective,
  ],
  declarations: [...components],
  exports: [...components],
})
export class OsosSelectModule {}
